import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle({ compact = false }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggle}
      title={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      aria-label={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      className={`mdd-btn mdd-btn-ghost ${compact ? "!p-2 !py-2" : ""}`}
    >
      {isDark ? (
        <Sun className="w-4 h-4 text-mdd-yellow" strokeWidth={1.75} />
      ) : (
        <Moon className="w-4 h-4 text-mdd-neon" strokeWidth={1.75} />
      )}
      {!compact && (
        <span className="text-xs font-mono uppercase tracking-wider">
          {isDark ? "Claro" : "Oscuro"}
        </span>
      )}
    </button>
  );
}
